import { useEffect, useState } from 'react';

import i18n from '../i18n.js';

export function useLocaleLoader(ns: string): boolean {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (import.meta.env.MODE === 'test' || import.meta.env.VITE_IGNORE_I18N) {
      setLoaded(true);
      return;
    }
    const loadLanguage = () =>
      i18n.loadNamespaces(ns).then(() => {
        i18n.emit('i18n:localeChanged');
        setLoaded(true);
      });
    i18n.on('languageChanged', loadLanguage);
    loadLanguage();
    return () => {
      i18n.removeResourceBundle(i18n.language || 'en', ns);
      i18n.off('languageChanged', loadLanguage);
    };
  }, []);
  return loaded;
}
